// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3rQPl","fileBtn":"File_fileBtn__1xwTe","closeBtn":"File_closeBtn__3HeB0","fileSelected":"File_fileSelected__jc_d0","disabled":"File_disabled__3lfju"};